module.exports = __webpack_public_path__ + "ug.2d2fff14052deb908165.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ug.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ug.svg
// module chunks = styles